import type { JobRole } from "../contexts/RoleContext";

export interface NpcContact {
  id: string;
  name: string;
  company: string;
  role: string;
  avatar: string;
  persona: string;
  description: string;
  isOnline: boolean;
  forRoles: JobRole[];
}

export interface MailMessage {
  id: string;
  from: "user" | "npc";
  text: string;
  time: string;
}

export interface MailThread {
  id: string;
  npcId: string;
  subject: string;
  preview: string;
  date: string;
  isRead: boolean;
  isStarred: boolean;
  status: "urgent" | "ongoing" | "waiting" | "action-needed";
  forRoles: JobRole[];
  messages: MailMessage[];
}

// ========================
// NPC 거래처 (직무별 분류)
// ========================
export const npcContacts: NpcContact[] = [
  // ─── A&R 전용 NPCs ────────────────────────────────────────────────────────
  {
    id: "npc_ar1",
    name: "김도현",
    company: "프리랜서 작곡가",
    role: "작곡가 / 비트메이커",
    avatar: "KD",
    persona: "열정적, 저작권에 민감",
    description: "인디 신에서 활동하는 떠오르는 작곡가. 데모곡 퀄리티가 높지만 저작권 귀속에 까다롭습니다.",
    isOnline: true,
    forRoles: ["AR", "CEO"],
  },
  {
    id: "npc_ar2",
    name: "최재영 팀장",
    company: "HIVE Entertainment A&R팀",
    role: "레이블 A&R 팀장",
    avatar: "CJ",
    persona: "비즈니스적, 협업 제안형",
    description: "대형 레이블 A&R 팀장. 공동 기획 제안을 자주 하며 선계약금 조건에 유연합니다.",
    isOnline: false,
    forRoles: ["AR", "CEO"],
  },

  // ─── 재무 전용 NPCs ──────────────────────────────────────────────────────
  {
    id: "npc_fin1",
    name: "이경훈 세무사",
    company: "이경훈 세무회계 사무소",
    role: "담당 세무사",
    avatar: "LK",
    persona: "형식적, 기한 중시",
    description: "엔터 전문 세무사. 부가가치세·원천징수 신고 기한을 항상 강조하며 서류 누락을 용납하지 않습니다.",
    isOnline: true,
    forRoles: ["Finance", "CEO"],
  },
  {
    id: "npc_fin2",
    name: "박민서 차장",
    company: "IBK기업은행 기업금융팀",
    role: "기업 대출 담당",
    avatar: "PM",
    persona: "신중함, 신용도 중시",
    description: "기업 대출 전담 차장. 신용등급과 담보 여부를 꼼꼼히 따지며 재무제표를 반드시 요청합니다.",
    isOnline: false,
    forRoles: ["Finance", "CEO"],
  },

  // ─── 마케팅 전용 NPCs ────────────────────────────────────────────────────
  {
    id: "npc_mkt1",
    name: "이상민 팀장",
    company: "서울전자 마케팅팀",
    role: "광고주 / 협찬 클라이언트",
    avatar: "LS",
    persona: "갑질형, 변덕스러움",
    description: "주요 광고주. 계약 완료 후에도 무리한 수정을 자주 요청하며 변덕스럽습니다.",
    isOnline: true,
    forRoles: ["Marketing", "CEO"],
  },
  {
    id: "npc_mkt2",
    name: "정소희 기자",
    company: "K-POP뉴스24",
    role: "엔터 전문 기자",
    avatar: "JS",
    persona: "빠른 판단, 단독 집착",
    description: "엔터 전문 기자. 단독 인터뷰나 보도자료 선공개를 조건으로 긍정적 기사를 쓸 의향이 있습니다.",
    isOnline: true,
    forRoles: ["Marketing", "CEO"],
  },

  // ─── 법무 전용 NPCs ──────────────────────────────────────────────────────
  {
    id: "npc_leg1",
    name: "김재호 과장",
    company: "멜론스트림 유통",
    role: "음원유통 계약 담당",
    avatar: "KJ",
    persona: "까다로움, 데이터 중시",
    description: "대형 유통사 과장. 계약서의 독소 조항을 자주 삽입하며 데이터 기반 협상을 선호합니다.",
    isOnline: false,
    forRoles: ["Legal", "CEO"],
  },
  {
    id: "npc_leg2",
    name: "강준혁 대표",
    company: "VK캐피탈",
    role: "투자자 / VC 대표",
    avatar: "GJ",
    persona: "공격적, 수익률 집착",
    description: "엔터 특화 VC 대표. 높은 수익률을 요구하며 경영 참여 조항을 계약서에 넣으려 합니다.",
    isOnline: true,
    forRoles: ["Legal", "CEO"],
  },
];

// ========================
// 직무별 메일 스레드
// ========================
export const mailThreads: MailThread[] = [
  // ─── A&R 메일 ──────────────────────────────────────────────────────────
  {
    id: "ar_m1",
    npcId: "npc_ar1",
    subject: "[데모 제출] 신곡 'Neon Drift' 검토 요청드립니다",
    preview: "안녕하세요, 이번에 작업한 R&B 계열 데모 3트랙을 검토해 주시길 부탁드립니다...",
    date: "2026.03.27 09:10",
    isRead: false,
    isStarred: true,
    status: "ongoing",
    forRoles: ["AR", "CEO"],
    messages: [
      {
        id: "msg1",
        from: "npc",
        text: "안녕하세요, K-ArtPEN A&R 담당자님.\n\n이번에 작업한 R&B 계열 데모 3트랙을 검토해 주시길 부탁드립니다. 트랙 리스트는 다음과 같습니다.\n\n1. Neon Drift (Main) - 3분 42초\n2. Neon Drift (Inst) - 3분 42초\n3. Late Night (Alternative) - 4분 11초\n\n저작권은 제가 80%, 귀사가 20%로 귀속했으면 합니다. 협의 가능하지만 완전 양도는 어렵습니다.\n\n긍정적인 답변 기다리겠습니다.\n\n- 김도현 드림",
        time: "09:10",
      },
    ],
  },
  {
    id: "ar_m2",
    npcId: "npc_ar2",
    subject: "신인 아티스트 공동 기획 제안 — HIVE×K-ArtPEN",
    preview: "안녕하십니까. HIVE Entertainment A&R팀 최재영입니다. 저희 측 신인 아티스트와의 공동 기획을...",
    date: "2026.03.26 15:40",
    isRead: true,
    isStarred: false,
    status: "action-needed",
    forRoles: ["AR", "CEO"],
    messages: [
      {
        id: "msg1",
        from: "npc",
        text: "안녕하십니까. HIVE Entertainment A&R팀 최재영 팀장입니다.\n\n저희 측에서 준비 중인 신인 아티스트 'ARIA'와 귀사의 루나&스타즈를 결합한 공동 기획 앨범을 제안드리고자 합니다.\n\n제안 조건:\n- 제작비: 저희 6 / 귀사 4 부담\n- 수익: 50/50 분배\n- 발매: 2026년 6월 목표\n- 선계약금: 협의 가능 (최소 1,000만원 수준)\n\n관심 있으시면 미팅 일정 잡아드리겠습니다. 검토 부탁드립니다.\n\n- 최재영 팀장 드림",
        time: "15:40",
      },
    ],
  },

  // ─── 재무 메일 ─────────────────────────────────────────────────────────
  {
    id: "fin_m1",
    npcId: "npc_fin1",
    subject: "[긴급] 1분기 부가가치세 신고 기한 안내 — 3/31까지",
    preview: "담당자님, 이번 1분기 부가가치세 신고 기한이 3월 31일까지입니다. 필요 서류를 즉시 제출...",
    date: "2026.03.27 08:00",
    isRead: false,
    isStarred: true,
    status: "urgent",
    forRoles: ["Finance", "CEO"],
    messages: [
      {
        id: "msg1",
        from: "npc",
        text: "K-ArtPEN 재무 담당자님께,\n\n이경훈 세무사입니다. 긴급 안내 드립니다.\n\n2026년 1분기 부가가치세 신고 기한이 **3월 31일(화)**까지입니다. 이후 지연 신고 시 가산세(10~20%)가 부과됩니다.\n\n제출 필요 서류:\n1. 매출/매입 세금계산서 목록\n2. 카드 매출 내역서\n3. 현금영수증 발행 내역\n4. 해외 용역 매입 내역 (있을 경우)\n\n서류 미제출 시 가산세 외에 세무조사 대상이 될 수 있습니다. 즉시 자료 취합 바랍니다.\n\n- 이경훈 세무사 드림",
        time: "08:00",
      },
    ],
  },
  {
    id: "fin_m2",
    npcId: "npc_fin2",
    subject: "기업 운전자금 대출 심사 결과 통보",
    preview: "지난달 신청하신 운전자금 대출 5,000만원 건 심사 결과를 안내드립니다...",
    date: "2026.03.26 14:20",
    isRead: true,
    isStarred: false,
    status: "action-needed",
    forRoles: ["Finance", "CEO"],
    messages: [
      {
        id: "msg1",
        from: "npc",
        text: "K-ArtPEN 재무 담당자님,\n\nIBK기업은행 기업금융팀 박민서 차장입니다.\n\n지난달 신청하신 운전자금 대출 5,000만원 심사 결과를 안내드립니다.\n\n✅ 조건부 승인\n- 승인 금액: 3,500만원 (요청액의 70%)\n- 이유: 최근 6개월 평균 매출 기준 DSR 한도 적용\n- 금리: 연 4.2% (변동)\n- 상환 기간: 24개월\n\n조건부 승인이므로 추가 담보 제공 시 전액 승인 가능합니다. 대표이사 인감증명서, 법인 등기부등본을 추가 제출해 주시기 바랍니다.\n\n- 박민서 차장 드림",
        time: "14:20",
      },
    ],
  },

  // ─── 마케팅 메일 ───────────────────────────────────────────────────────
  {
    id: "mkt_m1",
    npcId: "npc_mkt1",
    subject: "MV 협찬 제품 노출 시간 추가 요청 건",
    preview: "안녕하세요. 서울전자 이상민입니다. 계약서 사인 이후이긴 한데, 제품 노출을 3초 더...",
    date: "2026.03.27 10:30",
    isRead: false,
    isStarred: false,
    status: "urgent",
    forRoles: ["Marketing", "CEO"],
    messages: [
      {
        id: "msg1",
        from: "npc",
        text: "안녕하세요. 서울전자 마케팅팀 이상민입니다.\n\n지난주에 체결한 MV 협찬 계약 건으로 연락드립니다. 내부 회의 결과, 저희 제품 'Galaxy Tab 서울' 노출 시간을 기존 1초에서 3초 이상으로 늘려주셨으면 합니다.\n\n추가 비용은 물론 없이 진행해 주시길 바랍니다. 이미 계약서에 사인도 했고 촬영도 시작했다는 거 알지만, 브랜드 노출이 저희한테 너무 중요해서요.\n\n빠른 검토 부탁드립니다.\n\n- 이상민 팀장",
        time: "10:30",
      },
    ],
  },
  {
    id: "mkt_m2",
    npcId: "npc_mkt2",
    subject: "[기사 협의] 루나&스타즈 컴백 단독 인터뷰 제안",
    preview: "안녕하세요. K-POP뉴스24 정소희 기자입니다. 루나&스타즈 컴백 관련 단독 인터뷰를 요청드립니다...",
    date: "2026.03.26 11:50",
    isRead: true,
    isStarred: true,
    status: "waiting",
    forRoles: ["Marketing", "CEO"],
    messages: [
      {
        id: "msg1",
        from: "npc",
        text: "안녕하세요. K-POP뉴스24 정소희 기자입니다.\n\n루나&스타즈 컴백 기사와 관련해서 연락드립니다. 단독 인터뷰 형식으로 대형 특집 기사를 준비하고 있습니다.\n\n제안 조건:\n- 인터뷰 날짜: 3월 30일(월) 오후\n- 형식: 1:1 서면 인터뷰 (질문 10개 내외)\n- 기사 게재: 음원 발매 당일 오전 8시 선공개\n\n단독으로 기사를 드리는 대신, 보도자료도 저희 채널로 먼저 보내주시면 긍정적으로 커버하겠습니다. 어떻게 생각하시나요?\n\n- 정소희 기자 드림",
        time: "11:50",
      },
    ],
  },

  // ─── 법무 메일 ─────────────────────────────────────────────────────────
  {
    id: "leg_m1",
    npcId: "npc_leg1",
    subject: "음원 유통 계약서 초안 검토 요청 — 독소 조항 포함 의심",
    preview: "귀사와의 유통 계약을 위해 초안을 첨부합니다. 제 16조 정산 주기 조항을 특히 확인해 주시기 바랍니다...",
    date: "2026.03.27 09:45",
    isRead: false,
    isStarred: true,
    status: "urgent",
    forRoles: ["Legal", "CEO"],
    messages: [
      {
        id: "msg1",
        from: "npc",
        text: "K-ArtPEN 법무 담당자님께,\n\n멜론스트림 유통 김재호 과장입니다.\n\n이번 루나&스타즈 EP 유통 계약서 초안을 발송합니다. 아래 조항들을 특히 주목해 주십시오.\n\n[주요 조항 요약]\n- 제 8조: 유통 수수료 35% (협의 여지 있음)\n- 제 16조: 정산 주기 — 분기 1회 (90일 후 정산)\n- 제 22조: 계약 해지 후에도 2년간 동일 플랫폼 재계약 금지\n- 제 31조: 음원 삭제권 당사 보유 (분쟁 발생 시 즉시 삭제 가능)\n\n검토 후 수정 요청 사항을 알려주시면 재협상 가능합니다.\n\n- 김재호 과장 드림",
        time: "09:45",
      },
    ],
  },
  {
    id: "leg_m2",
    npcId: "npc_leg2",
    subject: "[투자 제안] Series A 10억원 투자 조건 협의",
    preview: "VK캐피탈입니다. K-ArtPEN의 성장 가능성을 높이 평가하여 Series A 투자를 제안드립니다...",
    date: "2026.03.25 16:00",
    isRead: true,
    isStarred: false,
    status: "action-needed",
    forRoles: ["Legal", "CEO"],
    messages: [
      {
        id: "msg1",
        from: "npc",
        text: "K-ArtPEN 법무 담당자님,\n\nVK캐피탈 강준혁 대표입니다.\n\nK-ArtPEN의 성장 가능성을 높이 평가하여 Series A 투자를 제안드립니다.\n\n[투자 조건 요약]\n- 투자 금액: 10억원\n- 지분: 15%\n- 조건부 조항:\n  * 이사회 옵저버석 1석 요구\n  * 연간 매출 목표 미달성 시 추가 지분 전환 옵션 (최대 5%)\n  * 3년 내 상장 또는 M&A 목표 명시\n\n계약서 초안은 귀사 법무팀 검토 후 재협상 가능합니다. 다만 추가 지분 전환 조항은 협상 불가입니다.\n\n- 강준혁 대표 드림",
        time: "16:00",
      },
    ],
  },
];

// ========================
// 직무별 NPC 필터 헬퍼
// ========================
export function getNpcsByRole(role: JobRole): NpcContact[] {
  return npcContacts.filter((n) => n.forRoles.includes(role));
}

export function getMailsByRole(role: JobRole): MailThread[] {
  return mailThreads.filter((m) => m.forRoles.includes(role));
}

// ========================
// 직무별 빠른 답장 템플릿
// ========================
export const quickRepliesByRole: Record<JobRole, string[]> = {
  CEO: [
    "검토 후 부서장에게 지시하겠습니다.",
    "조건 확인했습니다. 협의 진행 바랍니다.",
    "최종 결재는 법무 검토 완료 후 처리하겠습니다.",
  ],
  AR: [
    "데모 잘 받았습니다. 내부 청취 후 연락드리겠습니다.",
    "레퍼런스 및 무드보드 공유드리겠습니다.",
    "저작권 귀속 조건 재협의가 필요합니다.",
  ],
  Finance: [
    "서류 확인 후 영업일 3일 이내에 회신 드리겠습니다.",
    "가산세 방지를 위해 기한 내 처리하겠습니다.",
    "추가 담보 조건에 대해 내부 검토 중입니다.",
  ],
  Marketing: [
    "일정 조율 후 회신 드리겠습니다.",
    "계약서 검토 없이 수정 요청 수용은 어렵습니다.",
    "보도자료 초안 전달 후 협의 진행 가능합니다.",
  ],
  Legal: [
    "제 22조 및 제 31조 조항 수정을 강력히 요청합니다.",
    "독소 조항 삭제 없이는 계약 진행이 어렵습니다.",
    "투자 계약서 초안 법무 검토 후 회신 드리겠습니다.",
  ],
};

// ========================
// NPC 직무별 AI 응답 로직
// ========================
export const npcReplyLogic: Record<string, (userText: string) => string> = {
  npc_ar1: (r) =>
    r.includes("저작권") && r.includes("50")
      ? "저작권 50%는 받아들이기 어렵습니다. 최소 70%는 유지해야 합니다. 단, 공연권과 방송권은 귀사가 가져가셔도 좋습니다.\n\n- 김도현"
      : r.includes("무드보드") || r.includes("레퍼런스")
      ? "감사합니다! 레퍼런스 확인했습니다. 이 방향으로 작업 착수하겠습니다. 1차 수정본은 일주일 안에 드릴게요.\n\n- 김도현"
      : "검토해주신다니 감사합니다. 빠른 결정 부탁드립니다! 다른 레이블에서도 연락이 오고 있어서요.\n\n- 김도현",

  npc_ar2: (r) =>
    r.includes("미팅") || r.includes("일정")
      ? "좋습니다! 4월 2일(목) 오후 3시 어떠세요? 저희 사무실 또는 카페 어디서든 편하게 진행하겠습니다.\n\n- 최재영 팀장"
      : r.includes("조건") || r.includes("제작비")
      ? "제작비 비율은 5:5도 검토 가능합니다. 다만 수익 배분은 50:50 유지가 조건입니다. 선계약금은 2,000만원으로 올려드릴 수 있습니다.\n\n- 최재영 팀장"
      : "검토해 주셔서 감사합니다. 구체적인 조건이 있으시면 편히 말씀해 주세요.\n\n- 최재영 팀장",

  npc_fin1: (r) =>
    r.includes("서류") || r.includes("제출")
      ? "서류 잘 받았습니다. 내용 검토 후 신고 접수하겠습니다. 혹시 해외 용역 매입 내역이 있으시면 추가로 보내주세요.\n\n- 이경훈 세무사"
      : r.includes("기한") || r.includes("연장")
      ? "세무 신고 기한 연장은 부가가치세의 경우 불가합니다. 반드시 3월 31일까지 신고 완료해야 합니다. 지금 즉시 자료 취합 시작하세요.\n\n- 이경훈 세무사"
      : "확인했습니다. 추가 서류가 필요하면 연락드리겠습니다.\n\n- 이경훈 세무사",

  npc_fin2: (r) =>
    r.includes("담보") || r.includes("인감")
      ? "네, 인감증명서와 법인등기부등본 제출 후 3영업일 이내에 전액 승인 처리 가능합니다. 서류 제출해 주세요.\n\n- 박민서 차장"
      : r.includes("금리") || r.includes("이율")
      ? "현재 기준 금리 상 4.2%가 최저입니다. 신용등급 상향 시 다음 갱신일에 금리 인하 신청이 가능합니다.\n\n- 박민서 차장"
      : "네, 확인했습니다. 추가 문의 있으시면 연락 주세요.\n\n- 박민서 차장",

  npc_mkt1: (r) =>
    r.includes("불가") || r.includes("계약서")
      ? "알겠습니다. 그러면 저희가 추가 협찬비를 500만원 더 드리겠습니다. 대신 노출 시간 3초 반드시 부탁드립니다.\n\n- 이상민 팀장"
      : r.includes("수정") || r.includes("촬영")
      ? "감사합니다. 그런데 혹시 노출 각도도 정면으로 해주실 수 있나요? 로고가 잘 보여야 해서요.\n\n- 이상민 팀장"
      : "빠른 답변 감사합니다. 저희도 최대한 협력하겠습니다.\n\n- 이상민 팀장",

  npc_mkt2: (r) =>
    r.includes("인터뷰") || r.includes("일정")
      ? "완벽합니다! 3월 30일 오후 2시로 잡겠습니다. 질문지 사전 공유 드릴까요? 민감한 사안이 있으면 미리 알려주세요.\n\n- 정소희 기자"
      : r.includes("보도자료") || r.includes("단독")
      ? "보도자료 선공개 주시면 발매 당일 오전 8시 메인 기사로 올려드리겠습니다. 포털 메인 노출도 추진해 볼게요!\n\n- 정소희 기자"
      : "감사합니다. 빠른 회신 부탁드려요. 다른 소속사에서도 연락이 와서요.\n\n- 정소희 기자",

  npc_leg1: (r) =>
    r.includes("22조") || r.includes("31조") || r.includes("독소")
      ? "제 22조 재계약 금지 기간을 1년으로 단축하는 것은 가능합니다. 단, 제 31조 삭제는 어렵습니다. 조항 완화(30일 전 통보 후 삭제 가능)로 수정하겠습니다.\n\n- 김재호 과장"
      : r.includes("수수료") || r.includes("35%")
      ? "수수료 35%에서 30%까지는 내려드릴 수 있습니다. 단, 타 플랫폼 독점 공급 조건이 필요합니다.\n\n- 김재호 과장"
      : "검토 결과 공유해 주셔서 감사합니다. 추가 협의가 필요하면 언제든 연락 주세요.\n\n- 김재호 과장",

  npc_leg2: (r) =>
    r.includes("전환") || r.includes("옵션") || r.includes("추가 지분")
      ? "추가 지분 전환 조항은 투자 리스크 헤지를 위한 최소 조건이라 삭제는 어렵습니다. 다만 전환 비율을 5%에서 3%로 낮추는 것은 협의 가능합니다.\n\n- 강준혁 대표"
      : r.includes("이사회") || r.includes("옵저버")
      ? "옵저버석은 경영 참여가 아닌 정보 공유 목적입니다. 월 1회 보고서 공유로 대체하는 것은 어렵습니다.\n\n- 강준혁 대표"
      : "검토 중이십니까? 빠른 결정 부탁드립니다. 투자 결정은 이달 말까지입니다.\n\n- 강준혁 대표",
};
